import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS, { QUERY_KEYS } from 'services/urls';
import { IDevelopmentProject } from 'types/db/DevelopmentProjects';

const getGetDevelopmentProjects = async (organizationId: string): Promise<IDevelopmentProject[]> => {
    const response = await axiosInstance.get<IDevelopmentProject[]>(API_ENDPOINTS.DEVELOPMENT_PROJECTS(organizationId));
    return response.data;
};

export const useGetDevelopmentProjects = (
    organizationId: string,
    options?: Omit<UseQueryOptions<IDevelopmentProject[]>, 'queryKey' | 'queryFn'>,
) => useQuery<IDevelopmentProject[], Error>({
    queryKey: [QUERY_KEYS.DEVELOPMENT_PROJECTS],
    queryFn: () => getGetDevelopmentProjects(organizationId),
    staleTime: Infinity,
    ...(options ?? {}),
});
